// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"02c5405f","109":"f59548fe","284":"6f6b57cd","518":"6bed8664","613":"33e03ad5","630":"ff3114c9","889":"5e874942","890":"cf3de114","892":"002a3e4f"}[chunkId] + ".chunk.js";
};